import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { ReviewNote } from '../components/ui/ReviewNote';
import { useSeo } from '../hooks/useSeo';
import { pageMeta } from '../data/seo';
import { company, contact } from '../data/site';
import { images } from '../data/images';
const sections = [{
  title: 'Who we are',
  body: [`${company.legalName} (company registration ${company.registrationNumber}) is responsible for the personal information collected through this website. Postal address: ${contact.postal}.`]
}, {
  title: 'What we collect',
  body: ['When you submit the enquiry form, we collect your full name, company or organisation, email address, telephone number, the service you need, the project location, an optional budget range and timeline, and your project description.', 'The website does not ask you to create an account and does not collect payment information.']
}, {
  title: 'How we use it',
  body: ['We use these details only to respond to your enquiry, discuss your project and, where relevant, prepare a quotation. We do not sell your information or use it for unrelated marketing.']
}, {
  title: 'How enquiries are delivered',
  body: ['Enquiry forms are sent through a third-party form-handling service that forwards the submission to our company mailbox. That service processes the data only to deliver it to us.']
}, {
  title: 'How long we keep it',
  body: ['We keep enquiry information for as long as we need it to respond to you and manage any resulting work, and then delete it unless we have to keep it for legal or contractual reasons.']
}, {
  title: 'Your choices',
  body: [`You can ask to see, correct or delete the personal information you have sent us by emailing ${contact.email} or calling ${contact.phone.display}.`]
}];
export function PrivacyPolicy() {
  useSeo(pageMeta.privacy);
  return <>
      <PageHero title="Privacy policy" intro="How we handle the information you send through this website." image={images.surveyor} breadcrumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Privacy Policy'
    }]} data-id="element-741" data-mp="1a8keb7c02ceq" />
      <section className="bg-charcoal py-16 md:py-24" data-id="element-742" data-mp="10c7d7oe4kw9y">
        <div className="mx-auto max-w-3xl px-5 md:px-8" data-id="element-743" data-mp="w9kss8jsadms">
          <ReviewNote className="mb-10" data-id="element-744" data-mp="wavsnxa3z18m">
            This is a basic draft based only on what the enquiry form collects. Have it legally reviewed, including against
            Botswana's data protection legislation, and confirm the retention period and form provider before launch. It
            makes no claim of legal compliance.
          </ReviewNote>
          <div className="divide-y divide-white/10 border-y border-white/10" data-id="element-745" data-mp="1f6m0400t8ptw">
            {sections.map(section => <section key={section.title} className="py-8" data-id="element-746" data-mp="2bre7ft3xdz7l">
                <h2 className="font-display text-[26px] font-bold uppercase text-white" data-id="element-747" data-mp="26xickziyksgn">{section.title}</h2>
                {section.body.map(paragraph => <p key={paragraph} className="mt-3 text-[16px] leading-relaxed text-steel-200" data-id="element-748" data-mp="3uked2hqmvro4">
                    {paragraph}
                  </p>)}
              </section>)}
          </div>
        </div>
      </section>
    </>;
}